import(/* webpackMode: "eager", webpackExports: ["Card","CardBody"] */ "/home/app/tutorapp-alt/node_modules/@heroui/card/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/home/app/tutorapp-alt/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/home/app/tutorapp-alt/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["JoinActionSection"] */ "/home/app/tutorapp-alt/src/app/(static)/learn/[language]/[nativeLanguage]/[slug]/JoinActionSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["BookButton"] */ "/home/app/tutorapp-alt/src/app/(static)/schools/BookButton.tsx");
